/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Projects_Lifetime_1Inputs */

const cs_projects_lifetime_1 = /** @type {(inputs: Projects_Lifetime_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 měsíc`)
};

const en_projects_lifetime_1 = /** @type {(inputs: Projects_Lifetime_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 month`)
};

/**
* | output |
* | --- |
* | "1 month" |
*
* @param {Projects_Lifetime_1Inputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const projects_lifetime_1 = /** @type {((inputs?: Projects_Lifetime_1Inputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_Lifetime_1Inputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_projects_lifetime_1(inputs)
	return cs_projects_lifetime_1(inputs)
});